'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

// renders nested mustache templates; e.g. use case: we can allocate
// segments of translation text to be wrapped in components defined in
// a mustache context, like for an inline <a />
const MustacheNestedRender = ({
  template,
  context
}) => /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, template.map(([type, value, start, end, nestedTemplate]) => {
  if (type === 'text') return value;
  if (type === 'name') {
    const templateLookup = context.lookup(value);
    return templateLookup;
  }
  if (type === '#') {
    const key = `${start}${end}`;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const Component = context.lookup(value);
    if (!nestedTemplate) {
      return /*#__PURE__*/React__default["default"].createElement(Component, {
        key: key
      });
    }
    if (typeof nestedTemplate === 'string') {
      return /*#__PURE__*/React__default["default"].createElement(Component, {
        key: key
      }, nestedTemplate);
    }
    return /*#__PURE__*/React__default["default"].createElement(Component, {
      key: key
    }, /*#__PURE__*/React__default["default"].createElement(MustacheNestedRender, {
      template: nestedTemplate,
      context: context
    }));
  }
  return null;
}));

exports["default"] = MustacheNestedRender;
